var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21941 19.1808H5.31941V19.0808V8.71855C5.31941 6.46786 7.15047 4.63679 9.40117 4.63679H11.9394H12.0394V4.53679V4.00879V3.90879H11.9394H9.40117C6.74914 3.90879 4.59141 6.06652 4.59141 8.71855V19.0808V19.1808H4.69141H5.21941Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90488 19.3451V19.4451H9.00488H16.4833C18.4931 19.4451 20.1276 17.8101 20.1276 15.8008V6.91504V6.81504H20.0276H19.4996H19.3996V6.91504V15.8008C19.3996 17.4088 18.0913 18.7171 16.4833 18.7171H9.00488H8.90488V18.8171V19.3451Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98801 8.18582L8.9173 8.11511L8.84659 8.18582L8.47323 8.55917L8.40252 8.62988L8.47323 8.70059L16.3438 16.5712L16.4146 16.6419L16.4853 16.5712L16.8586 16.1978L16.9293 16.1271L16.8586 16.0564L8.98801 8.18582Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5076 8.18652L16.4369 8.11571L16.3661 8.18633L8.47333 16.0571L8.40252 16.1277L8.47314 16.1985L8.84597 16.5724L8.91658 16.6432L8.98739 16.5726L16.8802 8.70182L16.951 8.63121L16.8804 8.5604L16.5076 8.18652Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.4f5cf75bfca0fd20a17438cc6982a217.svg";
export { ForwardRef as ReactComponent };